import styled from 'styled-components';
import { space, color, borderColor } from 'styled-system';

const Divider = styled.hr`
  ${space};
  ${color};
  ${borderColor}
`;

Divider.defaultProps = {
  mx: 0,
  my: 3,
  border: 0,
  borderBottom: 1,
  borderColor: 'gray',
};

export default Divider;
